import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import { all } from 'rsvp';
import AdBlocker from 'cio/services/ad-blocker';
import CustomFormsService from 'cio/services/custom-forms';
import IntegrationsFormsController from './controller';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import { FormType } from 'cio/utils/forms';
import DS from 'ember-data';

export default class IntegrationsForms extends Route {
  @service adBlocker!: AdBlocker;
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Forms',
      path: this.routeName,
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);
    await all([
      this.facebookLeadAds.initialize(true),
      this.customForms.initialize(true),
      this.adBlocker.checkFacebook.perform(),

      // load segments and campaigns matched to forms
      // used when displaying them on both the list and detail views
      this.store.query('segment', {}),
      this.store.query('campaign', { type: 'form', sort: 'name', asc: 'true' }),
    ]);

    if (this.facebookLeadAds.enabled) {
      // Sync Facebook forms in CIO with Facebook
      try {
        await this.facebookLeadAds.updateAllForms();
      } catch (e) {}
    }
  }

  resetController(controller: IntegrationsFormsController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setProperties({
        from: null,
      });
    }
  }

  setupController(controller: IntegrationsFormsController, model: unknown, transition: Transition) {
    super.setupController(controller, model as any, transition);

    controller.setDefaults();

    controller.set(
      'facebookFormCampaigns',
      this.store
        .peekAll('campaign')
        .filter((c) => c.isFormTriggered && c.triggerFormTypes.includes(FormType.FacebookLeadAds)),
    );
  }
}
